var App = App || {};

App.MeetingLink = (function ($) {
	"use strict";
	function MeetingLink(data) {
		data = data || {};
		this.key = data.key || "";
		this.title = data.title || "";
		this.description = data.description || "";
		this.startsOn = data.startsOn ? new Date(data.startsOn) : null;
		this.url = data.url || "";
		this.formattedStartsOn = ko.pureComputed(() => {
			if (!this.startsOn || isNaN(this.startsOn)) return "";

			return new Intl.DateTimeFormat("en-US", {
				month: "long", day: "numeric", year: "numeric",
				hour: "numeric", minute: "2-digit", hour12: true, timeZoneName: "short" 
			})
				.format(this.startsOn)
				.replace(/\bAM\b|\bPM\b/, m => m.toLowerCase().replace("m", ".m."));
		});
		this.startsIn = ko.pureComputed(() => {
			const now = new Date();
			const then = this.startsOn;
			if (!then || isNaN(then)) return "";

			const diffMs = then - now;
			if (diffMs <= 0) return "Already started";

			const mins = Math.floor(diffMs / 60000);
			const hrs = Math.floor(mins / 60);
			const days = Math.floor(hrs / 24);

			if (days > 0) return `${days} day${days !== 1 ? 's' : ''}`;
			if (hrs > 0) return `${hrs} hour${hrs !== 1 ? 's' : ''}`;
			if (mins > 0) return `${mins} minute${mins !== 1 ? 's' : ''}`;
			return "Starting soon";
		});
	}

	const viewModel = {
		meetingLink: ko.observable(new MeetingLink()),
		navigateTo: function (data, event) {
			window.open(data.url);
			return;
		}
	}
	function getMeetingLink(productKey) {
		return $.ajax({
			url: `/api/webinars/meeting_link/${productKey}`,
			contentType: 'application/json; charset=utf-8',
			method: 'GET',
			dataType: 'json'
		}).fail(function (jqXHR) {
			App.Base.ShowError("Unable to complete request. Please try again.");
		});
	}

	function init() {
		const $modal = $("#meeting-speedbump");
		if ($modal.length) {
			ko.applyBindings(viewModel, $modal[0]);

			$modal.on("show.bs.modal", function (event) {
				const $trigger = $(event.relatedTarget);

				if (!$trigger.length)
					return;

				getMeetingLink($trigger.data("product-key") || "")
					.done(function (response) {
						if (!response) {
							App.Base.ShowError("API did not respond.");
							return;
						};

						if (response.success && response.data) {
							viewModel.meetingLink(new MeetingLink(response.data));
							return;
						}
					});
			});
		}
	}

	return {
		init: init
	};

})(jQuery);

$(function () {
	App.MeetingLink.init();
});